// extracted by mini-css-extract-plugin
export default {"alert":"NotificationContent_alert__bQthQ","alertBtn":"NotificationContent_alertBtn__ABpf7"};